module.exports = "https://img.xiyuyouxi.com/saas/img/shop_tab1_bg_on.f97252a8.png";